export interface Config {
  apiUrl: string;
  userPoolId: string;
  userPoolClientId: string;
  identityPoolId: string;
  region: string;
}

let config: Config | null = null;

export async function loadConfig(): Promise<Config> {
  if (config) {
    return config;
  }

  // First, try to load from API endpoint (gets latest config from SSM)
  try {
    // Determine API URL for config endpoint
    const apiBaseUrl = import.meta.env.VITE_API_URL ||
                      (window.location.hostname === 'localhost' ? 'http://localhost:3000' : '');

    const configUrl = apiBaseUrl ? `${apiBaseUrl}/v1/config` : '/v1/config';
    const response = await fetch(configUrl);

    if (response.ok) {
      const apiConfig = await response.json();
      config = {
        apiUrl: apiConfig.apiUrl || apiBaseUrl || '',
        userPoolId: apiConfig.userPoolId,
        userPoolClientId: apiConfig.userPoolClientId,
        identityPoolId: apiConfig.identityPoolId || '',
        region: apiConfig.region,
      };
      console.log('Configuration loaded from API');
      return config;
    }
  } catch (error) {
    console.log('Failed to load config from API, trying config.json:', error);
  }

  // Fallback: Try to load from config.json (production)
  try {
    const response = await fetch('/config.json');
    if (response.ok) {
      const jsonConfig: Config = await response.json();
      config = jsonConfig;
      console.log('Configuration loaded from config.json');
      return config;
    }
  } catch (error) {
    console.log('Config.json not found, using environment variables');
  }

  // Final fallback to environment variables (development)
  config = {
    apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || '',
    region: import.meta.env.VITE_AWS_REGION || 'ap-northeast-1',
  };

  console.log('Configuration loaded from environment variables');
  return config;
}

export function getConfig(): Config {
  if (!config) {
    throw new Error('Config not loaded. Call loadConfig() first.');
  }
  return config;
}